<template>
  <div id="invoice-page">
    <vx-tour
      @index-change="indexChangeTourStepFilter"
      @stop="stopTourStepFilter"
      name="tourStepFilterTransaction1"
      ref="tourStepFilterTransaction1"
      :steps="stepsFilter1"
      v-show="checkShowTourStepFilter1"
    />

    <vx-tour
      @index-change="indexChangeTourStepFilter"
      @stop="stopTourStepFilter"
      name="tourStepFilter2"
      ref="tourStepFilter2"
      :steps="stepsFilter2"
      v-show="checkShowTourStepFilter2"
    />
    <!-- <vx-card
      ref="filterCard"
      title="Filtre"
      class="bank-list-filters mb-8"
      actionButtons
      @refresh="reInitData"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full step-filter-1">
          <label class="text-sm opacity-75">Ürünler</label>
          <v-select
            :options="productOptions"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            no-data-text="Görüntüleyebileceğiniz sonuç bulunamadı!"
            v-model="productFilter"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-auto step-filter-2">
          <label class="text-sm opacity-75">Ödeme Sonucu</label>
          <v-select
            :options="payOptions"
            :clearable="false"
            no-data-text="Görüntüleyebileceğiniz sonuç bulunamadı!"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="payFilter"
            class="mb-4 md:mb-0"
          />
        </div>
      </div>
    </vx-card> -->

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  gridData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : gridData.length
                }}
                / {{ gridData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          :placeholder="$t('GridSearch')"
        />

        <vs-button class="mb-4 md:mb-0" @click="activePrompt = true"
          >Tabloyu Dışarı Aktar</vs-button
        >
      </div>

      <ag-grid-vue
        ref="agGridTable"
        id="permissionAg"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table vs-con-loading__container"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="gridData"
        colResizeDefault="shift"
        :animateRows="true"
        rowSelection="single"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        @grid-ready="onGridReady"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>

    <vs-popup
      v-show="syncBankDetailPopup && popupDesc"
      :title="popupTitle"
      fullscreen
      :active.sync="syncBankDetailPopup"
    >
      <div id="invoice-container">
        <div class="vx-row leading-loose p-base">
          <div class="vx-col w-full md:w-1/2 mt-base">
            <img src="@/assets/images/logo/logo.png" alt="FSMVU" width="200" />
          </div>
          <div class="vx-col w-full md:w-1/2 text-right">
            <h1>Hizmet</h1>
            <div class="invoice__invoice-detail mt-6">
              <h6>HİZMET NO.</h6>
              <p>#{{ popupDesc.Invoice.InvoiceKey }}</p>

              <h6 class="mt-4">İLK OLUŞTURULMA TARİHİ</h6>
              <p>{{ popupDesc.Invoice.CreateDate | date_tr }}</p>

              <h6 class="mt-4">SON FİYAT GÜNCELLENME TARİHİ</h6>
              <p>{{ popupDesc.Invoice.ModifiedDate | date_tr }}</p>
            </div>
          </div>
          <div class="vx-col w-full md:w-1/2 mt-12">
            <h5>MÜŞTERİ</h5>
            <div class="invoice__recipient-info my-4">
              <p>{{ popupDesc.UserInfo.FullName }}</p>
            </div>
            <div class="invoice__recipient-info my-4">
              <p>
                <b>T.C. Kimlik Numarası:</b>
                {{ popupDesc.UserInfo.IdentityNumber }}
              </p>
              <p><b>Öğrenci Numarası:</b> {{ popupDesc.UserInfo.StudentNo }}</p>
            </div>
          </div>
        </div>

        <div class="m-5">
          <!-- INVOICE TASKS TABLE -->

          <vs-table hoverFlat :data="popupDesc.Invoice.Transactions">
            <!-- HEADER -->
            <template slot="thead">
              <vs-th>İŞLEM NO</vs-th>
              <vs-th>LOGO ID</vs-th>
              <vs-th>İŞLEM TARİHİ</vs-th>
              <vs-th>SANAL POS</vs-th>
              <vs-th>BANKA CEVABI</vs-th>
              <vs-th>KART BİLGİLERİ</vs-th>
              <vs-th>ÖDEME TUTARI</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                :state="data[index].TransactionState == 0 ? 'success' : ''"
                v-for="(tr, index) in data"
                :key="index"
                style="font-size:11px"
              >
                <vs-td :data="data[index].VerifyEnrollmentRequestId">{{
                  data[index].VerifyEnrollmentRequestId
                }}</vs-td>
                <vs-td
                  :data="data[index].Transfer.LogoResultID"
                  :title="data[index].Transfer.LogoResultMessage"
                  >{{ data[index].Transfer.LogoResultID }}</vs-td
                >
                <vs-td :data="data[index].ModifiedDate">{{
                  data[index].ModifiedDate | date_tr
                }}</vs-td>
                <vs-td :data="data[index].Paymethod">{{
                  data[index].Paymethod
                }}</vs-td>
                <vs-td
                  :data="data[index].Response"
                  :title="data[index].Response"
                  >{{ data[index].Response | truncate(50) }}</vs-td
                >
                <vs-td
                  :data="data[index].Message"
                  :title="data[index].Message"
                  >{{ data[index].Message | truncate(100) }}</vs-td
                >
                <vs-td :data="data[index].PayPrice">{{
                  data[index].PayPrice | currency
                }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vs-popup>

    <vs-prompt
      title="Tablonuzu Dışarı Aktarın"
      class="export-options"
      @cancle="clearFields"
      @accept="exportToExcel"
      accept-text="Aktar"
      cancel-text="Vazgeç"
      @close="clearFields"
      :active.sync="activePrompt"
    >
      <vs-input
        v-model="fileName"
        placeholder="Dosya adını girin..."
        class="w-full"
      />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Hücre Genişliği Otomatik:</span>
        <vs-switch v-model="cellAutoWidth">Hücre Genişliği Otomatik</vs-switch>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

import InvoiceApi from "@/api/invoice";
import StaffApi from "@/api/staff";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";

import CellRendererDate from "./cell-renderer/CellRendererDate.vue";
import CellTransactionState from "./cell-renderer/CellTransactionState.vue";
import CellRendererPrice from "./cell-renderer/CellRendererPrice.vue";

import moment from "moment";
const VxTour = () => import("@/components/VxTour.vue");

Vue.directive("uppercase", {
  bind(el, _, vnode) {
    el.addEventListener("keyup", (e) => {
      e.target.value = e.target.value.toUpperCase();
      vnode.componentInstance.$emit("input", e.target.value.toUpperCase());
    });
  },
});

Vue.directive("uppercase-trim", {
  bind(el, _, vnode) {
    el.addEventListener("keyup", (e) => {
      e.target.value = e.target.value.toUpperCase();
      vnode.componentInstance.$emit(
        "input",
        e.target.value
          .toUpperCase()
          .trim()
          .split(" ")
          .join("")
      );
    });
  },
});

export default {
  components: {
    AgGridVue,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    VuePerfectScrollbar,
    VxAutoSuggest,
    CellRendererDate,
    CellTransactionState,
    CellRendererPrice,
    VxTour,
  },
  data() {
    return {
      fileName: "",
      activePrompt: false,
      cellAutoWidth: true,
      formats: ["xlsx", "csv", "txt"],
      selectedFormat: "xlsx",
      checkShowTourStepFilter1: true,
      headerTitle: [
        "Hizmet Numarası",
        "Adı Soyadı",
        "E-Posta",
        "Telefon",
        "Ürün Adı",
        "Genel Tutar",
        "Kalan Tutar",
        "Ödeme Durumu",
        "Oluşturma Tarihi",
      ],
      headerVal: [
        "Invoice.InvoiceKey",
        "UserInfo.FullName",
        "UserInfo.Email",
        "UserInfo.Phone",
        "Invoice.SettingGroup.ProductTitle",
        "Invoice.SpecialPrice",
        "Invoice.InvoicePrice",
        "IsPaymentRequired.Need",
        "Invoice.CreateDate",
      ],
      stepsFilter1: [
        {
          target: "#permissionAg",
          content: "Kayıtlara çift tıklayarak detaylarını görebilirsiniz.",
          params: {
            placement: "top",
            enableScrolling: true,
          },
        },
      ],
      checkShowTourStepFilter2: false,
      stepsFilter2: [
        {
          target: ".step-filter-2",
          content:
            "İşlem detaylarını görebilmek için herhangi bir banka hesabı seçin.",
          params: {
            placement: "bottom",
            enableScrolling: false,
          },
        },
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      navbarSearchAndPinList: {
        users: {
          key: "name",
          data: [],
        },
      },
      transactionData: [],

      productFilter: { label: "-tüm ürünler-", value: "" },
      productOptions: [],

      payFilter: { label: "-tüm sonuçlar-", value: "" },
      payOptions: [
        { label: "-tüm sonuçlar-", value: "" },
        { label: "Başarılı Ödemeler", value: "0" },
        { label: "Başarısız Ödemeler", value: "1" },
      ],

      showFullSearch: false,
      syncBankDetailPopup: false,
      popupTitleData: "",
      popupDescData: {
        Simulate: {},
        UserInfo: {},
        Invoice: {
          SettingGroup: {},
          Transactions: {},
        },
        IsPaymentRequired: {},
        PaidAmount: 0,
        Transfer: {},
      },
      formNewBank: {
        BankID: 0,
        BranchCode: "",
        BranchName: "",
        AccountOwner: "",
        AccountNumber: "",
        Iban: "",
        Swift: "",
      },
      dataLast: null,
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        filterParams: { newRowsAction: "keep" },
      },
      columnDefs: [
        {
          headerName: "#SettingGroupId",
          field: "Invoice.SettingGroup.InvoiceSettingGroupID",
          hide: true,
        },
        {
          headerName: "#InvoiceId",
          field: "Invoice.InvoiceID",
          hide: true,
        },
        {
          field: "IsPaymentRequired.NeedOrj",
          hide: true,
          valueGetter: function(params) {
            return params.data.IsPaymentRequired.Need;
          },
        },
        {
          headerName: this.$t("Table.Transactions.StudentNo"),
          field: "UserInfo.StudentNo",
          filter: true,
        },
        {
          headerName: this.$t("Table.Transactions.UserName"),
          field: "UserInfo.FullName",
          filter: true,
          minWidth: 240,
        },
        {
          headerName: this.$t("Borç Kartı"),
          field: "Invoice.SettingGroup.ProductTitle",
          minWidth: 240,
          filter: true,
        },
        {
          headerName: this.$t("Kart Borcu"),
          field: "Invoice.SpecialPrice",
          autoHeight: true,
          filter: false,
          cellRendererFramework: "CellRendererPrice",
        },
        {
          headerName: this.$t("Kalan Bakiye"),
          field: "Invoice.InvoicePrice",
          autoHeight: true,
          filter: false,
          minWidth: 280,
          cellRendererFramework: "CellRendererPrice",
        },
        {
          headerName: this.$t("Table.Transactions.State"),
          field: "IsPaymentRequired.Need",
          autoHeight: true,
          filter: false,
          cellRendererFramework: "CellTransactionState",
        },
        {
          headerName: this.$t("Table.Transactions.Date"),
          field: "Invoice.ModifiedDate",
          filter: true,
          valueGetter: function(params) {
            return moment(
              String(params.data.Invoice.Transactions[0].ModifiedDate)
            ).format("DD.MM.YYYY HH:mm");
          },
        },
      ],

      components: {
        CellRendererDate,
        CellTransactionState,
        CellRendererPrice,
      },
    };
  },
  watch: {
    productFilter(obj) {
      this.setColumnFilter(
        "Invoice.SettingGroup.InvoiceSettingGroupID",
        obj.value
      );
    },
    payFilter(obj) {
      var reduceValue = "";

      if (obj.value == "0") reduceValue = "false";
      else if (obj.value == "1") reduceValue = "true";

      this.setColumnFilter("IsPaymentRequired.NeedOrj", reduceValue);
    },
    async bankFilter(obj) {
      this.accountFilter = {
        label: "-önce banka seçin-",
        value: "",
      };
      this.dataLast = null;
      this.accountOptions = [];
      this.transactionData = [];
      this.gridApi.onFilterChanged();

      this.bankData.forEach((bank) => {
        if (bank.BankId == obj.value) {
          bank.Accounts.forEach((account) => {
            this.accountOptions.push({
              label: account.Aciklama + "(" + account.HesapNo + ")",
              value: account.HesapNo,
            });
          });
        }
      });

      this.accountFilter = {
        label: "-hesap numarası seçin-",
        value: "",
      };

      if (this.accountOptions.length > 0) {
        this.checkShowTourStepFilter1 = false;
        this.checkShowTourStepFilter2 = true;
      }
    },
    async accountFilter(obj) {
      if (!obj.value) return;
      this.checkShowTourStepFilter2 = false;

      var bankKey = "";

      switch (this.bankFilter.value) {
        case 1:
          bankKey = "halk";
          break;
        case 2:
          bankKey = "albaraka";
          break;
        case 3:
        case 6:
          bankKey = "vakif";
          break;
        case 4:
          bankKey = "ziraat";
          break;
        case 5:
          bankKey = "teb";
          break;
        case 7:
          bankKey = "qnb";
          break;
      }

      var data = {
        bankType: bankKey,
        accountId: obj.value,
      };

      this.$vs.loading({
        color: "#000",
        container: "#permissionAg",
        scale: 0.45,
      });

      this.dataLast = data;

      let response = await UserApi.getBankTransactions(data, this);

      if (!response.data.error) {
        this.transactionData = response.data.Model;
        this.gridApi.onFilterChanged();
      }

      setTimeout(() => {
        this.$vs.loading.close("#permissionAg .con-vs-loading");
      }, 100);
    },
  },
  computed: {
    popupTitle() {
      return this.popupTitleData;
    },
    popupDesc() {
      return this.popupDescData;
    },
    gridData() {
      return this.transactionData;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    printInvoice() {
      window.print();
    },
    currencyFormat(params) {
      return this.$options.filters.currency(params.data.Invoice.InvoicePrice);
    },
    async reInitData() {
      this.$refs.filterCard.removeRefreshAnimation();

      if (this.dataLast != null) {
        this.$vs.loading({
          color: "#000",
          container: "#permissionAg",
          scale: 0.45,
        });

        let response = await InvoiceApi.getMyTransactions({}, this);

        if (!response.data.error) {
          this.transactionData = response.data.model;
        }

        setTimeout(() => {
          this.$vs.loading.close("#permissionAg .con-vs-loading");
        }, 100);
      }
    },
    exportToExcel() {
      var count = this.gridApi.getDisplayedRowCount();
      var list = [];
      for (var i = 0; i < count; i++) {
        list.push(this.gridApi.getDisplayedRowAtIndex(i).data);
      }

      import("./../../../services/Export2Excel").then((excel) => {
        const data = this.formatJson(this.headerVal, list);

        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.clearFields();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => [
        v.Invoice.InvoiceKey,
        v.UserInfo.FullName,
        v.UserInfo.Email,
        v.UserInfo.Phone,
        v.Invoice.SettingGroup.ProductTitle,
        v.Invoice.InvoicePrice,
        v.IsPaymentRequired.Need ? "Ödeme Bekliyor" : "Ödeme Yapıldı",
        v.Invoice.CreateDate,
      ]);
    },
    clearFields() {
      (this.filename = ""),
        (this.cellAutoWidth = true),
        (this.selectedFormat = "xlsx");
    },
    stopTourStepFilter() {},
    indexChangeTourStepFilter(index) {
      this.checkShowTourStepFilter = true;
    },
    onSelectionChanged(event) {
      if (event.node.data) {
        this.popupTitleData =
          event.node.data.Invoice.InvoiceKey + " - Öğrenci Ödeme Kayıtları";
        this.popupDescData = event.node.data;

        if (
          this.popupDescData &&
          this.popupDescData.Invoice &&
          this.popupDescData.Invoice.Transactions &&
          this.popupDescData.Transfers
        ) {
          this.popupDescData.Invoice.Transactions.forEach((t) => {
            var transfer = this.popupDescData.Transfers.find(
              (x) => x.TransactionID == t.TransactionID
            );
            if (transfer) t.Transfer = transfer;
            else
              t.Transfer = {
                LogoResultMessage: "",
                LogoResultID: "",
              };
          });
        }

        this.syncBankDetailPopup = true;
      }
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.productFilter = {
        label: "-tüm ürünler-",
        value: "",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    showPersonList() {
      if (this.navbarSearchAndPinList.users.data.length > 0)
        this.showFullSearch = true;
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      this.$store.commit("TOGGLE_CONTENT_OVERLAY", query ? true : false);
    },
    selected(item) {
      var id = item.users.id;
      this.showFullSearch = false;
      if (id > 0) {
        this.$router.push({ name: "userview", params: { userId: id } });
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
      window.onresize = () => {
        this.gridApi.sizeColumnsToFit();
      };
    },
    getGridLocaleText(key, defaultValue) {
      var gridKey = "Grid_" + key;
      var value = this.$t(gridKey);
      return value === gridKey ? defaultValue : value;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    async fetchLoadData() {
      this.$vs.loading({
        color: "#000",
        container: "#permissionAg",
        scale: 0.45,
      });

      let response = await InvoiceApi.getMyTransactions({}, this);

      if (!response.data.error) {
        this.transactionData = response.data.model;
        this.dataLast = response.data.model;
        this.gridApi.onFilterChanged();
      }

      response = await StaffApi.getMyProducts(this);

      if (!response.data.error) {
        this.productOptions = response.data.model.map((m) =>
          (({ ProductTitle, InvoiceSettingGroupID }) => ({
            label: ProductTitle,
            value: InvoiceSettingGroupID,
          }))(m)
        );
        var filterArray = [this.productFilter];
        this.productOptions = filterArray.concat(this.productOptions);
      }

      setTimeout(() => {
        this.$vs.loading.close("#permissionAg .con-vs-loading");
      }, 100);
    },
  },
  beforeMount() {
    this.gridOptions.localeTextFunc = this.getGridLocaleText;
    this.gridOptions.onRowDoubleClicked = this.onSelectionChanged;
  },
  async mounted() {
    this.$emit("setAppClasses", "invoice-page");

    this.gridApi = this.gridOptions.api;

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }

    await this.fetchLoadData();
  },
  created() {
    this.$store.commit("TOGGLE_CONTENT_OVERLAY", false);
  },
  beforeDestroy: function() {
    [...document.getElementsByClassName("con-vs-popup")].map(
      (n) => n && n.remove()
    );
    // this.$signalr.$off("checkSorryRentAreaAuth", this.checkSorryRentAreaAuth);

    if (this.checkDateTimer) clearInterval(this.checkDateTimer);

    this.$store.commit("TOGGLE_CONTENT_OVERLAY", false);
  },
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}
</style>
<style lang="scss">
#page-transaction-list {
  .bank-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.search-person {
  width: 350px !important;
}

.search-person-close {
  top: 18px;
}
</style>
